import { View, Text, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';
import { Trophy, Users, Dumbbell, Calendar } from 'lucide-react-native';
import type { DuelType } from './types';

interface Props {
  colors: Record<string, string>;
  duelType: DuelType | null;
  onSelectType: (type: DuelType) => void;
  onBack: () => void;
}

const DUEL_TYPES: { type: DuelType; icon: typeof Trophy; title: string; description: string }[] = [
  {
    type: 'volume',
    icon: Users,
    title: 'TOTAL VOLUME',
    description: 'Who can lift the most total weight?',
  },
  {
    type: '1rm',
    icon: Dumbbell,
    title: 'HEAVIEST LIFT',
    description: 'Who can lift the most weight in one set?',
  },
  {
    type: 'consistency',
    icon: Calendar,
    title: 'MOST CONSISTENT',
    description: 'Who trains more days?',
  },
  {
    type: 'strength',
    icon: Trophy,
    title: 'PERSONAL RECORD',
    description: 'Who improves the most?',
  },
];

export default function TypeStep({ colors: c, duelType, onSelectType, onBack }: Props) {
  return (
    <View style={styles.stepContent}>
      <Text style={[styles.stepTitle, { color: c.text }]}>Choose Duel Type</Text>

      <ScrollView showsVerticalScrollIndicator={false}>
        {DUEL_TYPES.map(({ type, icon: Icon, title, description }) => (
          <TouchableOpacity
            key={type}
            style={[
              styles.typeCard,
              {
                backgroundColor: duelType === type ? c.accent + '20' : c.surface,
                borderColor: duelType === type ? c.accent : c.border,
              },
            ]}
            onPress={() => onSelectType(type)}>
            <Icon size={32} color={c.accent} />
            <Text style={[styles.typeTitle, { color: c.text }]}>{title}</Text>
            <Text style={[styles.typeDescription, { color: c.textSecondary }]}>
              {description}
            </Text>
          </TouchableOpacity>
        ))}
      </ScrollView>

      <TouchableOpacity
        style={[styles.backButton, { backgroundColor: c.surfaceVariant }]}
        onPress={onBack}>
        <Text style={[styles.backButtonText, { color: c.text }]}>Back</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  stepContent: { flex: 1, padding: 20 },
  stepTitle: { fontSize: 20, fontWeight: '800', marginBottom: 16 },
  typeCard: {
    borderWidth: 1, borderRadius: 2, padding: 20,
    alignItems: 'center', gap: 8, marginBottom: 12,
  },
  typeTitle: { fontSize: 18, fontWeight: '700' },
  typeDescription: { fontSize: 13, textAlign: 'center' },
  backButton: { padding: 14, borderRadius: 0, alignItems: 'center', marginTop: 8 },
  backButtonText: { fontSize: 15, fontWeight: '600' },
});
